import React from 'react'
import HOC from '../../components/HOC/HOC'

import Categories from '../../components/Categories/categories'

function CategoryListPage() {
  return (
     <HOC children={ <Categories />}/>
)
}

export default CategoryListPage